module.exports = __webpack_public_path__ + "media/bg.5f0ed187.mp4";